import React from 'react';
import { useTranslation } from 'react-i18next';
import PartyOutstandingReport from '@/components/finance/report-document/PartyOutstandingReport';

export const CustomerOutstandingPage: React.FC = () => {
  const { t } = useTranslation('finance');
  return (
    <div aria-label={t('customerOutstanding')}>
      <PartyOutstandingReport party="customer" />
    </div>
  );
};

export default CustomerOutstandingPage;
